// API service for CuttleFusion frontend
const getApiBaseUrl = () => {
  // Try global config first (for deployed version)
  if (typeof window !== 'undefined' && (window as any).CUTTLEFUSION_CONFIG) {
    return (window as any).CUTTLEFUSION_CONFIG.API_BASE_URL
  }
  
  // Fall back to environment variable
  return import.meta.env.VITE_API_BASE_URL || 'http://localhost:3000'
}

const API_BASE_URL = getApiBaseUrl()

export class ApiService {
  private baseUrl: string
  
  constructor() {
    this.baseUrl = API_BASE_URL
    console.log('API Service initialized with base URL:', this.baseUrl)
  }

  private async request<T>(endpoint: string, options: RequestInit = {}): Promise<T> {
    const url = `${this.baseUrl}${endpoint}`
    
    const config: RequestInit = {
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
      ...options,
    }

    try {
      const response = await fetch(url, config)
      
      if (!response.ok) {
        throw new Error(`API request failed: ${response.status} ${response.statusText}`)
      }
      
      return await response.json()
    } catch (error) {
      console.error('API request failed:', error)
      throw error
    }
  }

  // Game API methods
  async getGameStats() {
    return this.request('/api/game/stats')
  }

  async getUserProfile(address: string) {
    return this.request(`/api/users/${address}`)
  }

  async getCuttles(address?: string) {
    const endpoint = address ? `/api/cuttles?owner=${address}` : '/api/cuttles'
    return this.request(endpoint)
  }

  async getCuttleById(id: string) {
    return this.request(`/api/cuttles/${id}`)
  }

  // Trading API methods
  async getMarketplace() {
    return this.request('/api/marketplace')
  }

  async createTrade(tradeData: any) {
    return this.request('/api/trades', {
      method: 'POST',
      body: JSON.stringify(tradeData)
    })
  }

  async getTrades(address?: string) {
    const endpoint = address ? `/api/trades?user=${address}` : '/api/trades'
    return this.request(endpoint)
  }

  // Leaderboard API methods
  async getLeaderboard() {
    return this.request('/api/leaderboard')
  }

  // Health check
  async healthCheck() {
    return this.request('/api/health')
  }
}

export const apiService = new ApiService()